import styled from 'styled-components';

export const PhantomInput = styled.input`
  position: relative;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0 auto;
  border: 0;
  padding: 0;
  float: left;
`;
